import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Building } from "../app/building/building.model";
import { CountTranslationValues } from "../app/_component/pagination-client-side/count-translation";

@Pipe({
  name: "translateCount",
})
export class TranslateCountPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(count: number, ...args: any[]): any {
    let translateKey = args && args.length > 0 && args[0] ? args[0] : "ROW_";

    if (count >= 5 || count == 0) {
      translateKey += CountTranslationValues.MANY;
    } else if (count == 1) {
      translateKey += CountTranslationValues.ONE;
    } else {
      translateKey += CountTranslationValues.FEW;
    }

    return count + " " + this.translateService.instant(translateKey);
  }
}
